<template>
  <div class="app-main-inner-page">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('SeaExport.AntiTerroristFormattedAddress')"
      width="840px"
      :close-on-click-modal="false"
      class="app-main-inner edi-address-format-dialog"
    >
      <div class="app-main-inner-row">
        <div style="height: 490px;">
          <el-scrollbar style="height:500px;width:820px;" :native="true">
            <el-form :inline="true" label-width="40px" label-position="left" style="width: 640px;">
              <div class="el-form-item-wrapper" style="padding-left: 116px;">
                <el-form-item>
                  <el-checkbox :checked="addressForm.consolidationClosed === 1">{{ $t('SeaExport.LCLLastBillOfLading') }}</el-checkbox>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <div class="app-main-inner-row form-item-border-group">
                  <div class="form-item-group-label">
                    <span>{{ $t('Message.Shipper') }}</span>
                  </div>
                  <div>
                    <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                      <el-input v-model="addressForm.shipperLine1" />
                      <el-input v-model="addressForm.shipperLine2" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                      <el-input v-model="addressForm.shipperLine3" />
                      <el-input v-model="addressForm.shipperLine4" />
                      <el-input v-model="addressForm.shipperLine5" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Country')">
                      <el-input v-model="addressForm.shipperCountry" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Province')">
                      <el-input v-model="addressForm.shipperProvince" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.City')">
                      <el-input v-model="addressForm.shipperCity" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.ZIP')">
                      <el-input v-model="addressForm.shipperPostalcode" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Tel')">
                      <el-input v-model="addressForm.shipperTel" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Fax')">
                      <el-input v-model="addressForm.shipperFax" />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="el-form-item-wrapper">
                <div class="app-main-inner-row form-item-border-group">
                  <div class="form-item-group-label">
                    <span>{{ $t('Message.Consignee') }}</span>
                  </div>
                  <div>
                    <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                      <el-input v-model="addressForm.consigneeLine1" />
                      <el-input v-model="addressForm.consigneeLine2" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                      <el-input v-model="addressForm.consigneeLine3" />
                      <el-input v-model="addressForm.consigneeLine4" />
                      <el-input v-model="addressForm.consigneeLine5" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Country')">
                      <el-input v-model="addressForm.consigneeCountry" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Province')">
                      <el-input v-model="addressForm.consigneeProvince" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.City')">
                      <el-input v-model="addressForm.consigneeCity" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.ZIP')">
                      <el-input v-model="addressForm.consigneePostalcode" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Tel')">
                      <el-input v-model="addressForm.consigneeTel" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Fax')">
                      <el-input v-model="addressForm.consigneeFax" />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="el-form-item-wrapper">
                <div class="app-main-inner-row form-item-border-group">
                  <div class="form-item-group-label">
                    <span>{{ $t('Message.Notify') }}</span>
                  </div>
                  <div>
                    <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                      <el-input v-model="addressForm.notifyLine1" />
                      <el-input v-model="addressForm.notifyLine2" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                      <el-input v-model="addressForm.notifyLine3" />
                      <el-input v-model="addressForm.notifyLine4" />
                      <el-input v-model="addressForm.notifyLine5" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Country')">
                      <el-input v-model="addressForm.notifyCountry" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Province')">
                      <el-input v-model="addressForm.notifyProvince" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.City')">
                      <el-input v-model="addressForm.notifyCity" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.ZIP')">
                      <el-input v-model="addressForm.notifyPostalcode" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Tel')">
                      <el-input v-model="addressForm.notifyTel" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Fax')">
                      <el-input v-model="addressForm.notifyFax" />
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="el-form-item-wrapper">
                <div class="app-main-inner-row form-item-border-group">
                  <div class="form-item-group-label">
                    <span>{{ $t('Message.SecondNotify') }}</span>
                  </div>
                  <div>
                    <el-form-item :label="$t('Tool.Name')" class="form-item-long">
                      <el-input v-model="addressForm.alsonotifyLine1" />
                      <el-input v-model="addressForm.alsonotifyLine2" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Addr')" class="form-item-long">
                      <el-input v-model="addressForm.alsonotifyLine3" />
                      <el-input v-model="addressForm.alsonotifyLine4" />
                      <el-input v-model="addressForm.alsonotifyLine5" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Country')">
                      <el-input v-model="addressForm.alsonotifyCountry" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Province')">
                      <el-input v-model="addressForm.alsonotifyProvince" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.City')">
                      <el-input v-model="addressForm.alsonotifyCity" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.ZIP')">
                      <el-input v-model="addressForm.alsonotifyPostalcode" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Tel')">
                      <el-input v-model="addressForm.alsonotifyTel" />
                    </el-form-item>
                    <el-form-item :label="$t('SeaExport.Fax')">
                      <el-input v-model="addressForm.alsonotifyFax" />
                    </el-form-item>
                  </div>
                </div>
              </div>
            </el-form>
          </el-scrollbar>
        </div>
      </div>
      <div slot="footer">
        <div style="display: inline-block; position: absolute; left: 0; padding-left: 10px;">
          <el-button type="primary" @click="copyLatest">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-button>
          <el-button type="primary" @click="billCopy">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
          <el-button type="primary" @click="copyHbl">{{ $t('SeaExport.CopyFromHbl') }}</el-button>
        </div>
        <div style="display: inline-block;">
          <el-button type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
          <el-button @click="close">{{ $t('common.btn.close') }}</el-button>
        </div>
      </div>
    </el-dialog>
    <search-bill-no-dialog
      :visible.sync="searchBillNoDialog.visible"
      :params="searchBillNoDialog.params"
      @selected="selectAddressInfo"
    />
  </div>
</template>

<script>
import searchBillNoDialog from '../edi/searchBillNoDialog'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'

import { getGridSelected } from '@/utils/agGrid'
import { localCacheDatas } from '@/utils/cacheConfig'
// eslint-disable-next-line no-unused-vars
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export default {
  name: 'AddressFormatDialog',
  components: { searchBillNoDialog, cargoLeftRightResize },
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      cargoDoc: null,
      selectedJobs: [],
      initAddressForm: {
        consolidationClosed: 0,
        shipperLine1: '',
        shipperLine2: '',
        shipperLine3: '',
        shipperLine4: '',
        shipperLine5: '',
        shipperCountry: '',
        shipperProvince: '',
        shipperCity: '',
        shipperPostalcode: '',
        shipperTel: '',
        shipperFax: '',
        consigneeLine1: '',
        consigneeLine2: '',
        consigneeLine3: '',
        consigneeLine4: '',
        consigneeLine5: '',
        consigneeCountry: '',
        consigneeProvince: '',
        consigneeCity: '',
        consigneePostalcode: '',
        consigneeTel: '',
        consigneeFax: '',
        notifyLine1: '',
        notifyLine2: '',
        notifyLine3: '',
        notifyLine4: '',
        notifyLine5: '',
        notifyCountry: '',
        notifyProvince: '',
        notifyCity: '',
        notifyPostalcode: '',
        notifyTel: '',
        notifyFax: '',
        alsonotifyLine1: '',
        alsonotifyLine2: '',
        alsonotifyLine3: '',
        alsonotifyLine4: '',
        alsonotifyLine5: '',
        alsonotifyCountry: '',
        alsonotifyProvince: '',
        alsonotifyCity: '',
        alsonotifyPostalcode: '',
        alsonotifyTel: '',
        alsonotifyFax: ''
      },
      addressForm: {},
      // 上次地址详情（用于抄录上次，保存时记录地址详情）
      addressHistory: {},
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('SeaExport.BlNo'),
          field: 'hblNbr2',
          width: 180
        }
      ],
      rowData: [
        { billNo: 'BSYX200100001' },
        { billNo: 'BSYX200100002' }
      ],
      searchBillNoDialog: {
        visible: false,
        params: {}
      },
      lookup: {},
      cargoDocType: {
        MBL: 'MBL',
        MBL2: 'MBL2',
        HBL: 'HBL',
        HBL2: 'HBL2',
        AMS: 'AMS',
        MAWB: 'MAWB',
        HAWB: 'HAWB',
        HAWB2: 'HAWB2', // 形式分单
        AFR: 'AFR',
        MSC: 'MSC'
      }
    }
  },
  computed: {
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      if (newVal) {
        this.cargoDoc = this.params.cargoDoc
        this.addressForm = this.initAddressForm
      }
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    changeSelectRow() {
      this.cargoDoc = getGridSelected(this.gridOptions)[0]
    },
    // 抄录上次
    copyLatest() {
      this.addressForm = this.cargoDoc
    },
    // 单号抄录
    billCopy() {
      this.searchBillNoDialog.visible = true
      this.searchBillNoDialog.params = this.cargoDoc
    },
    // 抄录HBL
    copyHbl() {
      // const job = this.cargoDoc.job
      const job = this.cargoDoc
      if (job && job.lob === 'SI') {
        const hblSeaImDoc = this.getMainHbl(false)
        if (hblSeaImDoc) {
          this.copyDocDetail(hblSeaImDoc)
        }
      }
      if (job && job.lob === 'SE') {
        const hblSeaDoc = this.getMainHbl(false)
        if (hblSeaDoc) {
          this.copyDocDetail(hblSeaDoc)
        }
      }
    },
    save() {
      const afrAddress = this.addressForm
      afrAddress.state = 0
      afrAddress.docType = this.cargoDocType.AFR
      this.cargoDoc = afrAddress
      this.$message.success(this.$t('Message.SaveSuccessfully'))
    },
    close() {
      this.innerVisible = false
      this.addressForm = this.initAddressForm
    },
    // 检索单号弹窗选择地址信息后回调函数
    selectAddressInfo(data) {
      this.selectedJobs = data
    },
    getMainHbl(isCreate) {
      this.getCargoDoc(this.cargoDocType.HBL, false)
    },
    // 根据类型获取CargoDoc
    getCargoDoc(docType, create = false) {
      const cargoDocs = this.params.cargoDocs
      if (cargoDocs == null && !create) {
        return null
      }
      for (const index in cargoDocs) {
        if (cargoDocs[index].docType === docType) {
          return cargoDocs[index]
        }
      }
      if (!create) {
        return null
      }
      return this.newCargoDoc(this.cargoDoc.job, docType)
    },
    // 抄录HBL
    newCargoDoc(job, docType) {
      const cargoDoc = {}
      cargoDoc.job = job
      cargoDoc.docType = docType
      cargoDoc.mark = job.mark
      cargoDoc.cargoEnglishName = job.cargoEnglishName
      if (docType === this.cargoDocType.MBL && cargoDoc.notifyLine1 === '' || cargoDoc.notifyLine1 === null) {
        cargoDoc.notifyLine1 = 'SAME AS CONSIGNEE'
      }
      this.copyInfoFromSeaJob(job, cargoDoc)
      return cargoDoc
    },
    // 从海上进出口作业复制信息
    copyInfoFromSeaJob(job, cargoDoc) {
      if (cargoDoc.state > 1) {
        return
      }
      let port = null
      // 提单发货地，应该是seaopinput.placeOfReceipt
      cargoDoc.dispatchingPlace = job.dispatchingPlace
      // 提单起运港
      if (job.loadingPortCode && job.loadingPortCode.length > 0) {
        port = this.getSeaport(job.loadingPortCode)
        if (port) {
          cargoDoc.loadingPort = port.englishName
        }
      }
      // 提单卸货港
      if (job.dischargingPortCode && job.dischargingPortCode.length > 0) {
        port = this.getSeaport(job.dischargingPortCode)
        if (port) {
          cargoDoc.dischargingPort = port.englishName
        }
      }
      // 提单目的港
      if (job.destinationPortCode && job.destinationPortCode.length > 0) {
        port = this.getSeaport(job.destinationPortCode)
        if (port) {
          cargoDoc.destinationPort = port.englishName
        }
      }
      if (cargoDoc.docType !== this.cargoDocType.MBL && cargoDoc.docType !== this.cargoDocType.MBL2) {
        // 提单收货地
        cargoDoc.destinationPlace = job.destinationPlace
      }

      if (cargoDoc.docType === this.cargoDocType.MBL && job.isMasterFlag) {
        const office = this.$store.getters.currentOffice
        if (office) {
          cargoDoc.shipperLine1 = office.seaAddressLine1
          cargoDoc.shipperLine2 = office.seaAddressLine2
          cargoDoc.shipperLine3 = office.seaAddressLine3
          cargoDoc.shipperLine4 = office.seaAddressLine4
          cargoDoc.shipperLine5 = office.seaAddressLine5
          cargoDoc.shipperLine6 = office.seaAddressLine6
        }
      }

      // 通过参数BillOfLadingSynMode同步件毛体和包装
      CargoDocUtil.changeJobSynToBillOfLading(job, cargoDoc)
      // 根据参数判断是否同步小件数包装
      const isInsidePacking = parseInt(this.configMap.get('seaInsidePacking'))
      if (isInsidePacking === 1) {
        cargoDoc.insidePacking = job.insidePacking
      }
      // cargoDoc.issuerBL = 'UBI'
      ColumnUtils.customOrderFormTypeFunc(cargoDoc)
      // 新增时，如果已经选择提单方式，会重置为默认值
      if (cargoDoc.releaseType === 0) {
        const releaseType = parseInt(this.configMap.get('ReleaseTypeDefaultValue'))
        if (releaseType === 1) {
          cargoDoc.releaseType = 1
          cargoDoc.BLNumber = 'THREE'
        } else if (releaseType === 2) {
          cargoDoc.releaseType = 3
          cargoDoc.BLNumber = 'ONE'
        }
      } else { // 重置提单份数
        if (cargoDoc.releaseType === 1) {
          cargoDoc.BLNumber = 'THREE'
        } else {
          cargoDoc.BLNumber = 'ONE'
        }
      }
      if (this.cargoDoc.job.lob === 'SI') {
        cargoDoc.packing = job.packing
      }
      cargoDoc.state = 1
    },
    getSeaport(code) {
      const CODE_NAME = 'Seaport'
      let lookup = this.lookup[CODE_NAME]
      if (lookup === null) {
        lookup = {}
        this.lookup[CODE_NAME] = lookup
      }

      let codeMap = lookup['codeMap']
      if (!codeMap) {
        const ports = localCacheDatas[this.localCacheKeyPrefix + CODE_NAME]
        if (ports) {
          codeMap = {}
          lookup['codeMap'] = codeMap
          for (const index in ports) {
            codeMap[ports[index].code] = ports[index]
          }
        } else {
          console.error('Missing Seaport cache.')
          return null
        }
      }
      return codeMap[code]
    },
    /**
     * 单号，hbl抄录
     */
    copyDocDetail(cargoDoc) {
      if (!cargoDoc) {
        return
      }
      const addressForm = this.addressForm
      addressForm.shipperLine1 = this.getAfrAddressLine(cargoDoc.shipperLine1, 0)
      addressForm.shipperLine2 = this.getAfrAddressLine(cargoDoc.shipperLine1, 1)
      addressForm.shipperLine3 = cargoDoc.shipperLine2
      addressForm.shipperLine4 = cargoDoc.shipperLine3
      addressForm.shipperLine5 = cargoDoc.shipperLine4

      addressForm.consigneeLine1 = this.getAfrAddressLine(cargoDoc.consigneeLine1, 0)
      addressForm.consigneeLine2 = this.getAfrAddressLine(cargoDoc.consigneeLine1, 1)
      addressForm.consigneeLine3 = cargoDoc.consigneeLine2
      addressForm.consigneeLine4 = cargoDoc.consigneeLine3
      addressForm.consigneeLine5 = cargoDoc.consigneeLine4
      addressForm.notifyLine1 = this.getAfrAddressLine(cargoDoc.notifyLine1, 0)
      addressForm.notifyLine2 = this.getAfrAddressLine(cargoDoc.notifyLine1, 1)
      addressForm.notifyLine3 = cargoDoc.notifyLine2
      addressForm.notifyLine4 = cargoDoc.notifyLine3
      addressForm.notifyLine5 = cargoDoc.notifyLine4
      addressForm.shipperTel = cargoDoc.shipperTel
      addressForm.consigneeTel = cargoDoc.consigneeTel
      addressForm.notifyTel = cargoDoc.notifyTel
    },
    // index为0时取前35个字符，非0时取第35个后的字符
    getAfrAddressLine(line, index) {
      if (line === null || line.trim() === '') {
        return ''
      }
      // 最大字符长度
      const MAX_CHART = 35
      if (index === 0) {
        return line.substr(0, MAX_CHART)
      } else {
        if (line.length > MAX_CHART) {
          return line.substr(MAX_CHART, line.length)
        }
      }
      return ''
    }
  }
}
</script>

<style lang='scss'>
.edi-address-format-dialog {
  .el-scrollbar__wrap{
    overflow-x: hidden;
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-form-item__content {
     width: 110px;
   }
  .form-item-long {
    width: 560px;
    .el-form-item__content {
      width: 520px;
      .el-input {
        width: 220px !important;
        display: inline-block;
      }
    }
  }
  .form-item-border-group {
    padding-bottom: 0 !important;
    border-width: 0 0 1px 0;
    border-style: solid;
    border-color: black;
    .form-item-group-label {
      margin-right: 8px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-width: 0 1px 0 0;
      border-style: solid;
      border-color: black;
      span {
        padding-right: 30px;
        width: 100px;
      }
    }
  }
}
</style>
